interface IPushLoginEventProps {
  method: string;
}

export function pushloginEvent({ method }: IPushLoginEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "login",
      method,
      domain: "Nju",
    });
  }
}
